__webpack_require__.p = "/japanese-coaching-frontend/";